import { LoanApplicationResponse } from '@nemuru-eng/js-api-client';
import { useState } from 'react';

import { useProcessingStatusContext } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/_shared/components/ProcessingStrategy/context/ProcessingStrategyContext';
import { LoanApplicationEntity } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/_shared/components/ProcessingStrategy/entities/LoanApplication/LoanApplicationEntity';
import { ErrorResponse } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/_shared/components/ProcessingStrategy/types/ErrorResponse';

interface UseErrorResponseProps {
  loanApplication: LoanApplicationEntity;
}

export const useErrorResponse = ({ loanApplication }: UseErrorResponseProps) => {
  const { errorResponses, update } = useProcessingStatusContext();

  const [errorResponse, setErrorResponse] = useState<LoanApplicationResponse | undefined>(
    getErrorResponseFromId(loanApplication.id, errorResponses),
  );
  const [streaming, setStreaming] = useState(
    getErrorResponseFromId(loanApplication.id, errorResponses) === undefined ? true : false,
  );
  const [failed, setFailed] = useState(false);

  const getErrorResponse = async () => {
    if (errorResponse) return;
    try {
      const errorResponse = await loanApplication.getErrorResponse();
      await new Promise((resolve) => setTimeout(resolve, 500));
      if (!errorResponse) {
        return;
      }
      update({
        errorResponses: errorResponses
          ? [...errorResponses, { loanApplicationId: loanApplication.id, errorResponse }]
          : [{ loanApplicationId: loanApplication.id, errorResponse }],
      });
      setTimeout(() => setStreaming(false), 5000);
      setErrorResponse(errorResponse);
    } catch {
      setFailed(true);
    }
  };

  const resetErrorResponse = () => {
    update({
      errorResponses: errorResponses?.filter((errorResponse) => errorResponse.loanApplicationId !== loanApplication.id),
    });
    setErrorResponse(undefined);
    setStreaming(false);
  };

  return { errorResponse, streaming, failed, getErrorResponse, resetErrorResponse };
};

const getErrorResponseFromId = (loanApplicationId: string, errorResponses: ErrorResponse[]) => {
  return errorResponses.find((errorResponse) => errorResponse.loanApplicationId === loanApplicationId)?.errorResponse;
};
